import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'reducers'

import { MCBQS030InitRequest } from 'types/MCBQS030/MCBQS030InitRequest'
import { MCBQS030OutputPdfRequest } from 'types/MCBQS030/MCBQS030OutputPdfRequest'

const mCBQS030OutputPdfRequestValue: MCBQS030OutputPdfRequest = {
  jobSeekerByCompanyId: '',
  jobSeekerId: '',
  setPrintManagementId : '',
}

const mCBQS030InitRequestValue: MCBQS030InitRequest = {
  setPrintManagementId : '',
}

const initialState = {
  mCBQS030OutputPdfRequestValue,
  mCBQS030InitRequestValue,
};

const setOutputPdfDownloadReducer = createSlice({
  name: 'setOutputPdfDownload',
  initialState,
  reducers: {
    // MCBQS030 初期表示
    getInitDataForDownload(state, action: PayloadAction<MCBQS030InitRequest>) {
      state.mCBQS030InitRequestValue.setPrintManagementId = action.payload.setPrintManagementId
      return state
    },
    // 初期表示処理戻り値
    initEventRespons(state, action: PayloadAction<MCBQS030OutputPdfRequest>) {
      const data = action.payload;
      state.mCBQS030OutputPdfRequestValue.jobSeekerByCompanyId = data.jobSeekerByCompanyId;
      state.mCBQS030OutputPdfRequestValue.jobSeekerId = data.jobSeekerId;
      state.mCBQS030OutputPdfRequestValue.setPrintManagementId = state.mCBQS030InitRequestValue.setPrintManagementId
    },
  },
})

export const {
  getInitDataForDownload,
  initEventRespons,
} = setOutputPdfDownloadReducer.actions

export default setOutputPdfDownloadReducer.reducer

export const setOutputPdfDownloadState = (state: RootState) => state.setOutputPdfDownload